"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = void 0;

var _toTypeString = require("./to-type-string");

const assert = (input, condition, message) => {
  const messageType = typeof message;

  if (messageType !== 'string' && messageType !== 'function') {
    throw new TypeError(`"assert" expects message argument to be a string or a function returning a string, but was given "${(0, _toTypeString.toTypeString)(message)}"`);
  }

  if (typeof condition !== 'function') {
    throw new TypeError(`"assert" expects condition argument to be a function, but was given "${(0, _toTypeString.toTypeString)(condition)}"`);
  }

  if (Boolean(condition(input)) === false) {
    if (typeof message === 'function') {
      throw new TypeError(message(input));
    } else {
      throw new TypeError(message);
    }
  }

  return input;
};

exports.assert = assert;